export default __webpack_public_path__ + "static/BG2-68bac51bc2b6b03972a8b07f9e21cc1d.png";